/** Prefiere el porcentaje ya resuelto. Si no viene, usa score/maxScore. Nunca el puntaje crudo como porcentaje. */
export function activityPercentage(grade: {
  percentage?: number | null;
  score?: number | null;
  maxScore?: number | null;
}): number | null {
  if (grade.percentage != null && Number.isFinite(grade.percentage)) return grade.percentage;
  const maxScore = grade.maxScore ?? 0;
  if (grade.score != null && maxScore > 0) return (grade.score / maxScore) * 100;
  return null;
}
